@if(caja){
<div class="card_concepto" (click)="goToCategory(caja.data.url)">
  <img
    [src]="caja?.data?.image"
    class="img-fluid-product-mobile"
    [alt]="caja?.data?.title"
  />
  <div class="overlay">
    <div
      class="col-sm-12 h-100 flex justify-content-center align-items-center"
    >
      <h4 style="color: white; font-size: 22px">{{ caja.data.title }}</h4>
    </div>
  </div>
</div>
}
